import axios from "./axiosInstance";

const homePageAPI = {
  details: () => axios.get("details"),

  homePage: (payload) => axios.post("homepage", payload),

  fetchDetailsUsingSlug: (payload) =>
    axios.post("fetchDetailsUsingSlug", payload),

  fetchCategories: () => axios.post("homepage/category-for-navbar"),
};

export default homePageAPI;








// import axios from "./axiosInstance";
// import db from "../data/db.json";

// const mockAPI = {
 
//   homePage: async () => {
//     return db.homePage;
//   },

//   fetchCategories: async () => {
//     return {
//       code: 200,
//       message: "Categories fetched successfully",
//       success: true,
//       data: db.homePage.data.categories,
//     };
//   },

//   details: async () => {
//     return {
//       code: 200,
//       message: "Details fetched",
//       success: true,
//       data: {},
//     };
//   },

//   fetchDetailsUsingSlug: async (payload) => {
//     return {
//       code: 200,
//       message: "Details fetched",
//       success: true,
//       data: {},
//     };
//   },
// };

// const realAPI = {
//   details: () => axios.get("details"),
//   homePage: (payload) => axios.post("homepage", payload),
//   fetchDetailsUsingSlug: (payload) => axios.post("fetchDetailsUsingSlug", payload),
//   fetchCategories: () => axios.post("homepage/category-for-navbar"),
// };

// const homePageAPI =
//   process.env.REACT_APP_USE_MOCK === "true" ? mockAPI : realAPI;

// export default homePageAPI;
